import ROUTES from "src/js/router/routes";

export const DASHBOARD_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.DASHBOARD_PLANNING_ALERTS,
  ROUTES.DASHBOARD_PLANNING_ALERT_DETAILS,
  ROUTES.DASHBOARD_OWNERSHIP_ALERTS,
  ROUTES.DASHBOARD_DOCUMENTS,
  ROUTES.DASHBOARD_TOPUP,
  ROUTES.DASHBOARD_YOUR_ADDRESS,
  ROUTES.DASHBOARD_INTEGRATIONS,
];
export const SITE_ROUTES = [ROUTES.SITES];
export const MAP_ROUTES = [ROUTES.MAP, ROUTES.LEGACY_SEARCH, ROUTES.SEARCH];
